import { useState, useEffect } from 'react';
import useWS from '@/utils/ws';

export default (function (connect, share) {
  const { data, activeClose, sendMessage, connectionStatus } = useWS({
    url: 'push?uri=actual_params3',
    connect,
    share: share,
  });
  const [params, setParams] = useState({});

  useEffect(() => {
    if (data) {
      let newParams = JSON.parse(JSON.stringify(params));
      data.forEach(dev => {
        const params_data = dev.params_data;
        const devId = dev.device_id;
        if (!newParams[devId]) newParams[devId] = {};
        params_data.forEach(param => {
          const pid = '0x' + param.id.toString(16);
          if (!newParams[devId][pid]) {
            newParams[devId][pid] = {};
          }
          newParams[devId][pid].time = param.time;
          newParams[devId][pid].value = param.value;
        });
      });
      setParams(newParams);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return [params, sendMessage, connectionStatus, activeClose];
});
